// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

/**
 * @param props
 * @override add additoinal expands
 */
export const XngAddCustomExpand: any = (props: any) => {
    const additionalExpands = "getbadges,getstyledchildrencount,properties";
    props.getProductCollectionParameter = {
        ...props.getProductCollectionParameter,
        additionalExpands,
    };
};

/**
 * @param props
 * @override
 */
export const XngLoadFeaturedProducts: any = (props: any) => {
    const {
        parameter: { carouselType, category, brand },
    } = props;

    if (carouselType !== "featuredProducts" || (!category && !brand)) {
        return;
    }

    props.getProductCollectionParameter = {
        category,
        brand,
        relationship: "featuredProducts",
    };
};

/**
 * @param props
 * @override make featured categories force load products
 */
export const xLoadProducts: any = (props: any) => {
    if (!props.getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = props.extraProductCollectionParameter
        ? {
              getProductCollectionParameter: props.extraProductCollectionParameter,
              numberOfProductsToDisplay: props.parameter.numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP =
        props.parameter.carouselType === "recentlyViewed" && props.parameter.isProductDetailsPage;

    const isFeaturedProducts = props.parameter.carouselType === "featuredProducts";

    props.dispatch(
        loadProductInfoList({
            id: props.parameter.carouselId,
            getProductCollectionParameter: props.getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? props.parameter.productId : undefined,
            forceLoad: isRecentlyViewedOnPDP || isFeaturedProducts,
        }),
    );
};

addToChainBefore(chain, LoadProducts, XngAddCustomExpand);
addToChainBefore(chain, XngAddCustomExpand, XngLoadFeaturedProducts);
replaceInChain(chain, LoadProducts, xLoadProducts);
